export const buttonTypes = {
  link: 'link',
  trigger: 'trigger',
};
